<agr-page [pageTitle]="pageTitle()">
  <div class="wrapper--spacing-horizontal">
    <div class="row--container">
      <div class="row">
        <div class="col-8">
          <mat-card appearance="outlined">
            <mat-card-header>
              <mat-card-title> Authenticated User Token </mat-card-title>
            </mat-card-header>
            <mat-card-content>
              <button
                mat-flat-button
                color="primary"
                [cdkCopyToClipboard]="token$ | async"
                [cdkCopyToClipboardAttempts]="5"
              >
                <mat-icon>file_copy</mat-icon>
                Access Token
              </button>
              <button
                mat-flat-button
                color="accent"
                [cdkCopyToClipboard]="token$ | async"
                [cdkCopyToClipboardAttempts]="5"
                style="margin-left: 10px"
              >
                <mat-icon>file_copy</mat-icon>
                ID Token
              </button>
              <button
                mat-flat-button
                color="accent"
                (click)="this.refreshJwtAuthorizations()"
                style="margin-left: 10px"
              >
                <mat-icon>refresh</mat-icon>
                Refresh token
              </button>
            </mat-card-content>
          </mat-card>
        </div>
      </div>
      <div class="row">
        <div class="col-8">
          <mat-card appearance="outlined" class="spacing--margin-bottom">
            <mat-card-header>
              <mat-card-title> Authenticated User Token Decoded </mat-card-title>
            </mat-card-header>
            <mat-card-content>
              <pre class="text--pre">{{ user() | json }}</pre>
            </mat-card-content>
          </mat-card>
        </div>
      </div>
    </div>
  </div>
</agr-page>
